<template>
    <div :class="'box-action-container relative rounded-large p-6 my-2 ' + getApparenceClasses">
        <div v-if="badge != ''" class="badge absolute right-0 top-0 bg-badge-green p-2">{{ badge }}</div>
        <div class="box-action-content flex justify-between items-center">
            <div :class="'box-action-text flex-1 ' + getTextClasses" v-html="text"></div>
            <div class="box-action-button flex-1 flex-end">
                <div class="pl-3">
                    <button 
                        :data-testid="getDataTestid"
                        :class="getButtonClasses"
                        @click.prevent="handleClick"
                    >{{ label }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            badge: {
                type: String,
                default: ''
            },
            appareance: {
                type: String,
                default: 'blue',
                validator: function(value) {
                    return ['blue', 'white'].indexOf(value) !== -1;
                }
            }
        },
        methods: {
            handleClick() {
                this.$emit('click');
            }
        },
        data() {
            return {}
        },
        computed: {
            getDataTestid() {
                return this.label.toLowerCase();
            },
            getButtonClasses() {
                const blue = 'bg-white text-primary py-5 rounded-large font-semibold w-full p-1';
                const white = 'bg-white text-primary py-5 rounded-large font-semibold border border-primary w-full p-1';

                return this.appareance === 'blue' ? blue : white;
            },
            getApparenceClasses() {
                const blue = 'text-white bg-primary-300';
                const white = 'text-primary bg-white shadow-new';

                return this.appareance === 'blue' ? blue : white;
            },
            getTextClasses() {
                const blue = 'text-white';
                const white = 'text-black';

                return this.appareance === 'blue' ? blue : white;
            }
        }
    }
</script>

<style scoped>
.badge {
    border-radius: 22px;
    padding: 4px 16px;
    font-size: 12px;
    border: 1px solid;
    top: -14px;
    right: -10px;
}
</style>